// extracted by mini-css-extract-plugin
export default {"container":"ContentContainer_container__kg8dl"};